import {
  generateDecimal,
  randomIntFromChoices,
  randomIntFromInterval,
} from '~/bootcamp/Activities/utils/activities.utils'

import { TermRange } from './types'

export const roundMultiRanges = [
  { multiplierMin: 2, multiplierMax: 9, multiplicandFactor: 10, decimaNum: [0.1, 0.2, 0.5] },
  { multiplierMin: 2, multiplierMax: 9, multiplicandFactor: 100, decimaNum: [0.1, 0.2, 0.3, 0.5] },
  { multiplierMin: 10, multiplierMax: 99, multiplicandFactor: 100 },
  { multiplierMin: 10, multiplierMax: 99, multiplicandFactor: 1000 },
  { multiplierMin: 10, multiplierMax: 99, multiplicandFactor: 1000 },
]

const ROUND_NUM_THOUSANDTH_PLACE_CHOICES = { min: 2, max: 9 }
const ROUND_NUMBER_HUNDREDTH_PLACE_CHOICES = [100, 200, 500]

export function getRoundMultiDecimalTerms(
  level: number,
  previousNumbers?: number[],
): { decimalNumber: number; roundNumber: number } {
  const { min, max } = ROUND_NUM_THOUSANDTH_PLACE_CHOICES
  let roundNumber = randomIntFromChoices(getRangeOfNumbers(min, max))
  let decimalNumber = 0

  switch (level) {
    case 1: {
      const num = randomIntFromInterval(2, 9)
      decimalNumber = num + randomIntFromChoices([0.1, 0.2, 0.5])
      roundNumber *= 100
      break
    }

    case 2: {
      const num = randomIntFromInterval(10, 99)
      decimalNumber = num + randomIntFromChoices([0.1, 0.2, 0.5])
      roundNumber *= 1000
      break
    }

    case 3: {
      decimalNumber =
        randomIntFromInterval(10, 99) + randomIntFromChoices(getRangeOfNumbers(1, 7).map((item) => item / 10))
      roundNumber *= 1000
      break
    }

    case 4: {
      const num = randomIntFromInterval(100, 999)
      const randomDivisor = randomIntFromChoices([10, 100])
      decimalNumber = generateDecimal(num, randomDivisor)
      roundNumber = roundNumber * 1000 + randomIntFromChoices(ROUND_NUMBER_HUNDREDTH_PLACE_CHOICES)
      break
    }

    default:
      break
  }

  if (previousNumbers && previousNumbers.includes(decimalNumber)) {
    return getRoundMultiDecimalTerms(level, previousNumbers)
  }

  return { decimalNumber, roundNumber }
}

export function getRoundMultiTerms(level: number, previousNumbers?: number[]): TermRange<number> {
  const { multiplierMin, multiplierMax, multiplicandFactor } = roundMultiRanges[level - 1]
  const { min, max } = ROUND_NUM_THOUSANDTH_PLACE_CHOICES

  const multiplier = randomIntFromInterval(multiplierMin, multiplierMax, previousNumbers)
  const roundNumber = randomIntFromChoices(getRangeOfNumbers(min, max))

  let multiplicand = roundNumber * multiplicandFactor
  if (level === 5) {
    multiplicand = roundNumber * 1000 + randomIntFromChoices(ROUND_NUMBER_HUNDREDTH_PLACE_CHOICES)
  }

  return { multiplier, multiplicand }
}

function getRangeOfNumbers(start: number, end: number): number[] {
  const len = end - start + 1
  return new Array(len).fill(start).map((item, i) => item + i)
}
